import { MembershipFee } from '../model/membership-fee';

export interface MembershipFeeView extends MembershipFee {
  dateOfPaymentDate: Date | null;
  contributionPeriodFromMonthDate: Date | null;
  contributionPeriodToMonthDate: Date | null;
}

export function isoToDate(s?: string): Date | null {
  if (!s) return null;
  const d = new Date(s);
  return isNaN(+d) ? null : d;
}


export function ymToDate(ym?: string): Date | null {
  if (!ym) return null;
  const cleaned = ym.replace('-', '');
  if (!/^\d{6}$/.test(cleaned)) return null;
  const y = Number(cleaned.slice(0, 4));
  const m = Number(cleaned.slice(4, 6)) - 1;
  return new Date(y, m, 1);
}


// Contributions before the euro (1 January 2002) are amounts in Belgian francs: they must not be shown as euros
export const FIRST_EURO_YEAR = 2002;

export function isEuroMembershipFee(fee: MembershipFee | null | undefined): boolean {
  const paymentDate = isoToDate(fee?.dateOfPayment);
  return !!paymentDate && paymentDate.getFullYear() >= FIRST_EURO_YEAR;
}

export const toMembershipFeeView = (raw: MembershipFee): MembershipFeeView => ({
  ...raw,
  dateOfPaymentDate: isoToDate(raw?.dateOfPayment),
  contributionPeriodFromMonthDate: ymToDate(raw?.contributionPeriodFromMonth),
  contributionPeriodToMonthDate: ymToDate(raw?.contributionPeriodToMonth),
});
